import type { BannerDataLoader } from './types'

export function makeBannerDataLoader(loader: BannerDataLoader): BannerDataLoader {
  return loader
}
